export default function BackIcon({ ...rest }) {
  // 17242A
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M10.6668 5.99967H1.3335M1.3335 5.99967L6.00016 10.6663M1.3335 5.99967L6.00016 1.33301"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
